export enum DownloaderProgressStatus {
  Processing = 'processing',
  Merging = 'merging',
  Rendering = 'rendering',
  CreatingZip = 'creating zip',
  Finished = 'finished',
  Error = 'error',
}
